import React, { useState, useEffect } from 'react';
import { TextField } from '@material-ui/core';
import InputMask from 'react-input-mask';
import { useDebounce } from '../../../../../../hooks/useDebounce';

function CEPInputMask(props) {
  const { inputRef, mask, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask="99999-999"
    />
  );
}

export default function CEPField({ defaultCEP, onCEPSuccess, onCEPError, autoFocus, autoComplete }) {
  const [hasError, setHasError] = useState(false);
  const [cep, setCEP] = useState(defaultCEP || '');
  const debouncedCEP = useDebounce(cep, 250);

  useEffect(() => {
    const getCEP = async () => {
      if(!debouncedCEP) {
        return;
      }

      const unmaskedCEP = debouncedCEP?.replace('-', '')?.replace('_', '')?.trim();

      if(unmaskedCEP?.length < 8) {
        return;
      }

      try {
        const response = await fetch(`https://viacep.com.br/ws/${unmaskedCEP}/json/`);
        const data = await response.json();

        if(data?.erro) {
          setHasError(true);
          onCEPError();
          return;
        }

        onCEPSuccess({
          cep,
          street: data?.logradouro,
          district: data?.bairro,
          uf: data?.uf,
          city: data?.localidade,
        });
      } catch(error) {
        console.log(error);
      } finally {

      }
    }
    
    getCEP();
  }, [debouncedCEP]);

  return (
    <TextField
      autoFocus={autoFocus}
      label="CEP"
      value={cep}
      autoComplete={autoComplete}
      onChange={e => setCEP(e.target.value)}
      InputProps={{
        inputComponent: CEPInputMask
      }}
      InputLabelProps={{
        shrink: true
      }}
      error={hasError}
      helperText={hasError ? 'CEP inválido' : ''}
    />
  )
}